import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import pluralize from 'pluralize';

import { PRE_DEFINED_TIME_KEYS } from '../data/time';

dayjs.extend(duration);
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

export function getRelativeTimeKey(activityTime: string): string {
  const activityDate = dayjs(activityTime);

  if (activityDate.isToday()) {
    return PRE_DEFINED_TIME_KEYS.today;
  } else if (activityDate.isYesterday()) {
    return PRE_DEFINED_TIME_KEYS.yesterday;
  } else if (activityDate.isAfter(dayjs().subtract(7, 'day'))) {
    return PRE_DEFINED_TIME_KEYS.previous7Days;
  } else if (activityDate.isAfter(dayjs().subtract(30, 'day'))) {
    return PRE_DEFINED_TIME_KEYS.previous30Days;
  } else {
    return activityDate.format('MMMM YYYY'); // e.g., "August 2024"
  }
}

/**
 * Formats a duration in days into a human-readable string
 * @param days - The number of days to format
 * @returns A formatted string like "2 years 3 months 5 days" or "0 days" if no duration
 */
export function formatDurationFromDays(days: number | null | undefined): string {
  if (days == null || !Number.isFinite(days)) {
    return '0 days';
  }

  const durationObj = dayjs.duration(days, 'days');

  const years = durationObj.years();
  const months = durationObj.months();
  const remainingDays = durationObj.days();

  const parts: string[] = [];

  if (years > 0) {
    parts.push(`${years} ${pluralize('year', years)}`);
  }
  if (months > 0) {
    parts.push(`${months} ${pluralize('month', months)}`);
  }
  if (remainingDays > 0 || parts.length === 0) {
    parts.push(`${remainingDays} ${pluralize('day', remainingDays)}`);
  }

  return parts.join(' ');
}
